import React from "react";
import rsk from "../../asset/image/rrrrr.PNG";
import ads from "../../asset/image/picc.JPG";
import easy from "../../asset/image/easy-resale.JPG";
import exap from "../../asset/image/exap.JPG";

const Projects = () => {
    const projects = [
        {
            title: "RsikderCorporation Ecommerce",
            url: "https://rsikdercorporation.com/",
            description:
                "A fully dynamic eCommerce platform with an international payment system.",
            technologies: "MERN Stack",
            image: rsk,
            time: "November 1 - Present",
        },
        {
            title: "Queue Management System",
            url: "http://fejiton552-001-site1.etempurl.com",
            description:
                "A token management system. Login: admin@gmail.com | Pass: Password1",
            technologies: "ASP.NET Core 6, C#, Entity Framework, MSSQL, JavaScript",
            image: ads,
            time: "July 28 - Present",
        },
        {
            title: "PalkiTop Solution",
            url: "https://all-assistant.onrender.com/",
            description: "A service platform like SHEBA.XYZ (Backend API implementation).",
            technologies: "React, Tailwind CSS, Node.js, Express, JWT, Mongoose",
            image: easy,
            time: "January 25, 2022 - Present",
        },
        {
            title: "DoctorApp",
            url: "https://github.com/FahimNuman/DoctorApp-Asp.NetCoreMvc",
            description:
                "A CRUD-based application where users can manage their profiles with image uploads.",
            technologies: "ASP.NET Core, C#, MSSQL, Bootstrap, Parsley.js",
            image: exap,
            time: "May 15, 2023 - May 15, 2023",
        },
    ];

    return (
        <section id="projects" className="py-16 bg-gray-100">
            <div className="max-w-6xl mx-auto px-6 lg:px-12">
                <h1 className="text-4xl font-bold text-center text-gray-800 mb-12">My Latest Projects</h1>
                <div className="grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {projects.map((project) => (
                        <div key={project.title} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300">
                            <img src={project.image} alt={project.title} className="w-full h-52 object-cover" />
                            <div className="p-6">
                                <p className="text-xs text-gray-500 font-semibold mb-2">{project.time}</p>
                                <h2 className="text-2xl font-semibold text-gray-800 mb-3">{project.title}</h2>
                                <p className="text-gray-600 mb-3">{project.description}</p>
                                <p className="text-sm text-gray-700 mb-4">
                                    <span className="font-semibold">Technologies:</span> {project.technologies}
                                </p>
                                <div className="flex justify-center">
                                    <a href={project.url} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition">Live Site</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;
